import { createStore } from 'zustand/vanilla'

import {
  ChannelSlice,
  UserSlice,
  createChannelSlice,
  createUserSlice,
} from '@nx/bidding-engine'

import { AppStoreState, appDefaultState } from './defaultState'

export type AppStore = UserSlice & ChannelSlice

export const createAppStore = (initState: Partial<AppStoreState>) => {
  return createStore<AppStore>()((set, get, store) => ({
    ...appDefaultState,
    ...createUserSlice(set, get, store),
    ...createChannelSlice(set, get, store),
    ...initState,
  }))
}
